import { useState, useEffect } from "react";
import Axios from "axios";
import { useBaseUrl } from "../ApiContext";

const useCart = (userToken) => {
  const baseUrl = useBaseUrl();
  const [cart, setCart] = useState(null);
  useEffect(() => {
    const fetchCart = async () => {
      try {
        const response = await Axios.get(`${baseUrl}/cart`, {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        });
        setCart(response.data);
      } catch (error) {
        console.log("Error during getting cart data", error);
      }
    };
    if (userToken) {
      fetchCart();
    }
  }, [baseUrl, userToken]);

  return { cart, setCart };
};

export default useCart;
